import type { TradeItem } from '@/types';

/**
 * What the Fee Income / Cash Pool Interest Accrual / Net Amount / Total Rate cells show. As on the
 * trade page (PnlTable), the fee and cost legs exist on a fee trade only, and every
 * figure stands on today's rate where one exists, like the Daily Earnings cell beside
 * them. Net Amount keeps the backend's own base: on a rebate it is Trade Margin Value,
 * so for non-cash collateral it differs from Daily Earnings (collateral value, LR-395).
 * One rule for the cell, the copy and the CSV; the backend sort
 * (`api/v1/positions/sort_keys.py`) follows it too.
 */
export const RATE_LEG_CELLS = {
  fee_income: (t: TradeItem): number | null =>
    t.rate_entry_mode === 'fee' ? (t.fee_income ?? null) : null,
  cost_of_collateral: (t: TradeItem): number | null =>
    t.rate_entry_mode === 'fee'
      ? (t.effective_cost_of_collateral ?? t.cost_of_collateral ?? null)
      : null,
  net_amount: (t: TradeItem): number | null => {
    const v = t.effective_net_amount ?? t.net_amount ?? null;
    // A zero rate times the direction serialises as "-0.0000", which would print -0.00.
    return v === 0 ? 0 : v;
  },
  // Once the pool accrues the cash the trade accrues at the fee alone, while the
  // stored total_rate keeps fee − benchmark. The cell's floating-rebate dash stays
  // in the cell.
  total_rate: (t: TradeItem): number | null =>
    (t.pool_accrues_interest ? t.fee_percent : t.total_rate) ?? null,
};
